import { ComingSoonPage } from './ComingSoonPage';

export default function AVM() {
  return (
    <ComingSoonPage
      title="Automated Valuation Model"
      description="Get an instant data-driven estimate of any property's market value in Ethiopia."
      canonical="https://ethiorealestates.com/avm"
      tagline="AI-powered property valuations using real market data — launching soon."
    />
  );
}
